import { type RefObject, useEffect } from 'react';

/**
 * Adds the {className} to the {ref}.
 */
export const useWebClassName = (ref: RefObject<any>, className: string | null) => {
  useEffect(() => {
    if (!ref.current || !className) return;

    const { current } = ref;

    current.classList.add(className);

    return () => {
      current.classList.remove(className);
    };
  }, [ref, className]);
};
